import React, { CSSProperties, SyntheticEvent, useCallback, useMemo } from "react";

import { Dimmer, Icon, Image, Loader, SemanticCOLORS, SemanticICONS } from "semantic-ui-react";

// Types
type LoadingIconProps = {
  id?: any;
  style?: CSSProperties;
  color?: SemanticCOLORS;
  dimmerStyle?: CSSProperties;
  disabled?: boolean;
  img?: string;
  inverted?: boolean;
  loading?: boolean;
  name?: SemanticICONS;
  onClick?: (e: SyntheticEvent) => any;
};

const LoadingIcon = (props: LoadingIconProps) => {
  const style = useMemo(
    () => ({ cursor: props.disabled ? "" : "pointer", ...props.style }),
    [props.disabled, props.style]
  );

  const handleClick = useCallback(
    (e: SyntheticEvent) => {
      if (props.disabled) {
        e.stopPropagation();

        return;
      }

      props.onClick?.(e);
    },
    [props.disabled, props.onClick]
  );

  const handleDoubleClick = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
    },
    [props.onClick]
  );

  // Memo
  const dimmerStyle = useMemo(
    () => ({
      background: "transparent",
      margin: "-1px 0 0 -2px",
      padding: 0,
      ...props.dimmerStyle,
    }),
    [props.dimmerStyle]
  );

  return (
    <span style={{ position: "relative" }} onDoubleClick={handleDoubleClick}>
      {props.img ? (
        <Image id={props.id ?? `LoadingIcon-Image`} style={style} disabled={props.disabled} src={props.img} onClick={handleClick} />
      ) : (
        <Icon
          id={props.id ?? `LoadingIcon-Icon`}
          style={style}
          color={props.color ?? "blue"}
          disabled={props.disabled}
          name={props.name}
          like
          onClick={handleClick}
        />
      )}
      <Dimmer
        style={dimmerStyle}
        active={props.loading}
        inverted={props.inverted ?? true}
        size="mini"
      >
        <Loader size="mini" inline />
      </Dimmer>
    </span>
  );
};

LoadingIcon.displayName = "LoadingIcon";

export default React.memo(LoadingIcon);
